export function getOrgWithExceededLimitPublic(orgTree, selectedOrganizationIds, prevSelectedOrganizationIds) {
    if (orgTree.length === 0 || !(selectedOrganizationIds === null || selectedOrganizationIds === void 0 ? void 0 : selectedOrganizationIds.length)) {
        return undefined;
    }
    // Helper to collect all descendant ids for a node (excluding the node itself by default)
    // Returns a Map where key is base child id and value is child name
    // Skips network children: if child's path does not start with the root parent's name, we ignore that child and its subtree
    const collectDescendantIds = (node, rootPath) => {
        const ids = new Map();
        for (const child of node.children || []) {
            // skip network child and its subtree
            if (!child.path.startsWith(rootPath)) {
                continue;
            }
            const baseId = child.id.split('_')[0];
            ids.set(baseId, child.name);
            const childMap = collectDescendantIds(child, rootPath);
            for (const [k, v] of childMap) {
                ids.set(k, v);
            }
        }
        return ids;
    };
    // Use a Map to aggregate exceeded children across roots to avoid duplicates
    const exceededChildrenMap = new Map();
    for (const root of orgTree) {
        const max = root.maxNumberOfMembershipsPerOrgTree;
        if (!max || max < 1) {
            continue; // no limit configured for this root
        }
        // Count how many selected items belong to this root's subtree (children only)
        const descendantMap = collectDescendantIds(root, root.path);
        const selectedDescendantMap = new Map();
        for (const id of selectedOrganizationIds) {
            const name = descendantMap.get(id);
            if (name) {
                selectedDescendantMap.set(id, name);
            }
        }
        if (selectedDescendantMap.size > max) {
            for (const [k, v] of selectedDescendantMap) {
                if (!prevSelectedOrganizationIds.includes(k)) {
                    exceededChildrenMap.set(k, v);
                }
            }
        }
    }
    if (exceededChildrenMap.size === 0) {
        return undefined;
    }
    return exceededChildrenMap;
}
